module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-alert', {
    staticClass: "notification-top",
    attrs: {
      "variant": "secondary",
      "dismissible": "",
      "show": _vm.show
    },
    on: {
      "dismissed": _vm.dismiss
    }
  }, [_c('b-list-group', _vm._l((_vm.items), function(item) {
    return _c('b-list-group-item', {
      key: item.notificationId,
      staticClass: "m-1",
      attrs: {
        "variant": _vm.priorityVariant[item.priority - 1]
      }
    }, [(item.priority === 3) ? _c('b-img', {
      staticClass: "danger-notification-icon",
      attrs: {
        "left": "",
        "src": require("@/assets/images/danger-icon.svg")
      }
    }) : (item.priority === 2) ? _c('b-img', {
      staticClass: "warning-notification-icon",
      attrs: {
        "left": "",
        "src": require("@/assets/images/warning-icon.svg")
      }
    }) : _c('b-img', {
      staticClass: "info-notification-icon",
      attrs: {
        "src": require("@/assets/images/info-icon.svg"),
        "left": ""
      }
    }), _vm._v("\n        " + _vm._s(item.text) + "\n      ")], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11a3b220","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/notification-container/NotificationContainer.vue
// module id = 752
// module chunks = 1